// extracted by mini-css-extract-plugin
export default {"root":"styles_root__3i6Ns","actions":"styles_actions__0KKMn"};